import * as React from "react";
// React bootstrap
import { mediaService } from "../../services";
import { IMedia } from "../../types";
import * as Styled from "./StarRating.styled";

import './star-rating.css';

interface IProps {
    mediaItem: IMedia;
    mediaRating: number;
    sessionToken: string;
    onRatingSuccess: (idx?: number) => void;
}


export const StarRating: React.FC<IProps> = ({ mediaItem, mediaRating, sessionToken, onRatingSuccess }) => {

    const [rating, setRating] = React.useState(0);
    const [hoverIntent, setHoverIntent] = React.useState(0);

    const handleOnClick = (evt: any, val: number) => {
        evt.preventDefault();
        evt.stopPropagation();

        setRating(val);

        try {
            mediaService.addMediaRating(sessionToken, mediaItem.mediaId, val);
            onRatingSuccess();
        } catch (err) {
            console.log(err);
        }
    };

    const handleOnMouseEnter = (evt: any, val: number) => {
        setHoverIntent(val);
    };

    const handleOnMouseLeave = (evt: any, val: number) => {
        setHoverIntent(val);
    };

    React.useEffect(() => {
        setRating(mediaRating);
    }, [mediaRating, setRating]);

    return (
        <>
            <Styled.StarRatingWrapper data-rating={rating} className="star-rating">
                {[...Array(5)].map((_, i) => {
                   const idx = i + 1;
                    return (
                        <Styled.StarButton
                            type="button"
                            title={`Rate this Film (${idx} stars)`}
                            key={idx}
                            className={idx <= (hoverIntent || rating) ? 'active' : 'inactive'}
                            onMouseDown={(evt) => handleOnClick(evt, idx)}
                            onMouseEnter={(evt) => handleOnMouseEnter(evt, idx)}
                            onMouseLeave={(evt) => handleOnMouseLeave(evt, rating)}>
                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill="rgba(255,255,255, 0.6)"
                                    d="M5.49615 4.89328L1.24282 5.50995L1.16749 5.52528C1.05345 5.55556 0.949484 5.61555 0.866215 5.69915C0.782947 5.78274 0.723356 5.88694 0.693529 6.0011C0.663701 6.11526 0.664705 6.23529 0.696439 6.34893C0.728172 6.46257 0.789498 6.56576 0.874154 6.64795L3.95549 9.64728L3.22882 13.8839L3.22015 13.9573C3.21317 14.0752 3.23766 14.1929 3.29112 14.2983C3.34458 14.4037 3.42508 14.4929 3.52438 14.557C3.62368 14.621 3.73821 14.6575 3.85625 14.6627C3.97429 14.6679 4.0916 14.6416 4.19615 14.5866L8.00015 12.5866L11.7955 14.5866L11.8622 14.6173C11.9722 14.6606 12.0918 14.6739 12.2087 14.6558C12.3255 14.6377 12.4355 14.5888 12.5272 14.5141C12.619 14.4395 12.6892 14.3418 12.7307 14.231C12.7722 14.1203 12.7835 14.0005 12.7635 13.8839L12.0362 9.64728L15.1188 6.64728L15.1708 6.59062C15.2451 6.49913 15.2938 6.38958 15.312 6.27315C15.3301 6.15671 15.3171 6.03753 15.2742 5.92777C15.2313 5.818 15.1601 5.72157 15.0678 5.64829C14.9755 5.57501 14.8654 5.52751 14.7488 5.51062L10.4955 4.89328L8.59415 1.03995C8.53914 0.928305 8.45397 0.834292 8.34828 0.768551C8.24259 0.702811 8.12062 0.667969 7.99615 0.667969C7.87169 0.667969 7.74971 0.702811 7.64403 0.768551C7.53834 0.834292 7.45317 0.928305 7.39815 1.03995L5.49615 4.89328Z" />
                            </svg>
                        </Styled.StarButton>
                    );
                })}
            </Styled.StarRatingWrapper>
        </>
    );
};